// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lSB3q","icon":"styles_icon__m6vUZ","text":"styles_text__t-7U-"};